<template>
  <div class="puesto-tree" :style="getColortree(puesto)">
    <small style="margin: 10px;">
      Puesto: {{ puesto.name }} - NIVEL {{ puesto.level }}
    </small>
    <div
      class="puesto-children"
      v-if="puesto.children && puesto.children.length"
    >
      <PuestoTree
        v-for="child in puesto.children"
        :key="child.value"
        :puesto="child"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PuestoTree",
  props: {
    puesto: { type: Object, required: true },
  },
  methods: {
    getColortree(puesto) {
      const colors = [
        "#FFB6C1",
        "#B0E0E6",
        "#FFD700",
        "#90EE90",
        "#FFA07A",
        "#DDA0DD",
        "#87CEFA",
      ];
      return {
        border: `3px solid ${colors[puesto.level % colors.length]}`,
        margin: "4px",
      };
    },
  },
  created() {
    // Asignar el puesto principal al nodo
    //console.log("Node:", this.puesto);
  },
};
</script>

<style scoped>
.puesto-tree {
  margin-left: 18px;
  margin-top: 4px;
}

.puesto-item {
  padding: 6px 12px;
  border-radius: 8px;
  background: #f6f6f6;
  border: 1px solid #eee;
  margin-bottom: 4px;
  font-weight: 500;
}

.puesto-children {
  margin-left: 18px;
}
</style>
